import { useCallback } from 'react'

import { useBlocker } from './useBlocker'

/**
 * Prompts the user with an Alert before they leave the current screen.
 * tx is [`Transition`] from [`history`] package which is peer-dependencies
 * and not exported
 */
export function usePrompt(message: string, when = true) {
  const blocker = useCallback(
    (tx: any) => {
      if (window.confirm(message)) tx.retry()
    },
    [message]
  )

  useBlocker(blocker, when)
}
